export interface State {
  locationType: LocationTypeEnum;
  locations: number[];
  isSuccess:boolean;
}
export enum LocationTypeEnum {
  None = -1,
  Municipality = 0,
  Province = 1
}
